import {useState} from "react"
import {Button} from "./Button"
import Menu from "lucide-react/dist/esm/icons/menu";
import X from "lucide-react/dist/esm/icons/x";
import {Link, useNavigate} from "react-router-dom"

export default function Header() {
    const navigate = useNavigate()
    const [menuOpen, setMenuOpen] = useState(false)

    const handleLogin = () => {
        navigate(`/login`)
    }

    return (
        <header className="flex flex-col bg-primary text-white sticky z-50 top-0 p-0">
            <div className="flex items-center justify-between p-2 gap-2">
                <Link to="/" className="text-xl font-bold hover:underline ml-3"
                      aria-label={`Home Page`}>
                    Home
                </Link>

                <div className="flex items-center gap-4">

                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => setMenuOpen(true)}
                        aria-label="Open Menu"
                    >
                        <Menu/>
                    </Button>
                </div>
            </div>

            {menuOpen && (
                <div className="fixed inset-0 bg-primary-dark text-white flex flex-col z-50">
                    <div className="flex items-center justify-between p-4">
                        <div className="text-xl font-bold">Menu</div>
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => setMenuOpen(false)}
                            aria-label="Close Menu"
                        >
                            <X/>
                        </Button>
                    </div>

                    <div className="flex flex-col items-center gap-4 p-4 text-lg">
                        <Link to="/" onClick={() => setMenuOpen(false)} className="hover:underline">
                            Home
                        </Link>
                    </div>

                    <div className="p-4 border-t border-white/20 mt-auto">
                        <Button variant="menu" onClick={handleLogin}>
                            Login or Register
                        </Button>
                    </div>
                </div>
            )}
        </header>
    )
}
